/**
 * apiUrl vazio = mesmo origem (passa pelo Vite proxy `/api` → :3003 em dev).
 * Manter same-origin é obrigatório pra cookie SameSite=Lax do NextAuth funcionar em fetch.
 * Em prod, setar VITE_API_URL=https://bookdental.com.br (mesmo site, cross-subdomain OK com COOKIE_DOMAIN=.bookdental.com.br).
 */
export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? "",
  landingUrl: import.meta.env.VITE_LANDING_URL ?? "http://localhost:3003",
  adminUrl: import.meta.env.VITE_ADMIN_URL ?? "http://localhost:3005",
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? "",
} as const;
